import { z } from 'zod';
import { useSettings } from '@/store/settings';
import { useRecords } from '@/store/records';

const BackupSchema = z.object({
  app: z.literal('cardcounter'),
  version: z.literal(1),
  settings: z.object({ lang: z.string(), colors: z.record(z.string(), z.string()), subs: z.record(z.string(), z.number()) }),
  records: z.record(z.string(), z.object({ best: z.number(), at: z.string() })),
});
export type Backup = z.infer<typeof BackupSchema>;

export function exportBackup(): string {
  const s = useSettings.getState();
  const b: Backup = {
    app: 'cardcounter',
    version: 1,
    settings: { lang: s.lang, colors: s.colors, subs: s.subs },
    records: useRecords.getState().records,
  };
  return JSON.stringify(b, null, 2);
}

/** Returns an error message, or null on success. */
export function importBackup(json: string): string | null {
  let data: unknown;
  try {
    data = JSON.parse(json);
  } catch {
    return 'invalid JSON';
  }
  const parsed = BackupSchema.safeParse(data);
  if (!parsed.success) return 'not a CardCounter backup';
  const { settings, records } = parsed.data;
  const st = useSettings.getState();
  if (settings.lang === 'uk' || settings.lang === 'ru' || settings.lang === 'en') st.setLang(settings.lang);
  const c = settings.colors;
  if (c.accent && c.a && c.b && c.mfill && c.mcell)
    st.setColors({ accent: c.accent, a: c.a, b: c.b, mfill: c.mfill, mcell: c.mcell, combo: c.combo ?? st.colors.combo, blocker: c.blocker ?? st.colors.blocker });
  for (const [key, i] of Object.entries(settings.subs)) {
    const [mode, level] = key.split(':');
    if (mode && level) st.setSub(mode, level, i);
  }
  useRecords.setState({ records });
  return null;
}

export function downloadText(filename: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
  const a = Object.assign(document.createElement('a'), { href: url, download: filename });
  a.click();
  URL.revokeObjectURL(url);
}
